"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlockchain = exports.fetchJNT = exports.isContractAddress = exports.calculateAtomicCost = exports.estimateAtomicImportGas = exports.estimateAtomicExportGas = exports.AtomicDenomination = void 0;
const ethers_1 = require("ethers");
const asset_1 = require("../asset");
const transaction_1 = require("../transaction");
const encoding_1 = require("./encoding");
const errors_1 = require("./errors");
exports.AtomicDenomination = BigInt(1000000000);
const AtomicSignatureCost = BigInt(1000);
const AtomicBaseCost = BigInt(10000);
function calculateAtomicGas(size, signaturesCount) {
    return size + AtomicSignatureCost * signaturesCount + AtomicBaseCost;
}
function estimateAtomicExportGas(chainAssetId, exportedAssets, importFeeAssetId) {
    const signaturesCount = transaction_1.JEVMExportTransaction.estimateSignaturesCount(exportedAssets, chainAssetId, importFeeAssetId);
    const size = transaction_1.JEVMExportTransaction.estimateSize(signaturesCount);
    return calculateAtomicGas(BigInt(size), BigInt(signaturesCount));
}
exports.estimateAtomicExportGas = estimateAtomicExportGas;
function estimateAtomicImportGas(inputsCount, outputsCount) {
    const size = transaction_1.JEVMImportTransaction.estimateSize(inputsCount, outputsCount);
    return calculateAtomicGas(BigInt(size), BigInt(inputsCount));
}
exports.estimateAtomicImportGas = estimateAtomicImportGas;
function calculateAtomicCost(gas, baseFee) {
    return (gas * baseFee) / exports.AtomicDenomination;
}
exports.calculateAtomicCost = calculateAtomicCost;
function isContractAddress(assetId) {
    // ethers.isAddress supports also ICAP addresses so check if it is hex too
    return (0, encoding_1.isHex)(assetId) && ethers_1.ethers.isAddress(assetId);
}
exports.isContractAddress = isContractAddress;
async function fetchJNT(provider, assetId) {
    if (transaction_1.AssetId.validate(assetId)) {
        throw new errors_1.ChainError(`cannot fetch invalid asset id ${assetId}`);
    }
    const jvm = provider.jvmApi;
    if (jvm.chain.registeredAssets.has(assetId)) {
        return jvm.chain.registeredAssets.get(assetId);
    }
    const response = await jvm.getAssetDescription(assetId).catch((error) => {
        throw new errors_1.ChainError(`could not fetch asset id ${assetId}: ${error.message}`);
    });
    const asset = new asset_1.TokenAsset(response.assetID, response.name, response.symbol, response.denomination);
    // use the jvm registered assets as a cache
    jvm.chain.addRegisteredAsset(asset);
    return asset;
}
exports.fetchJNT = fetchJNT;
function getBlockchain(provider, blockchainId) {
    const chain = provider.mcn.getChain(blockchainId.value);
    if (typeof chain === 'undefined') {
        throw new errors_1.ChainError(`unregistered chain id: ${blockchainId.value}`);
    }
    return chain;
}
exports.getBlockchain = getBlockchain;
